<template>
    <div>
<v-layout justify-center>
    <v-flex xs2>
        <v-list subheader></v-list>
    </v-flex>
     <v-flex xs8>
        <div id="drawflow" v-on:drop="drop" v-on:dragover="allowDrop"></div>
      </v-flex>
</v-layout>
    </div>
</template>
<script>
import Api from "@/services/Api";
import Drawflow from "drawflow";
import styleDrawflow from "drawflow/dist/drawflow.min.css"; // eslint-disable-line no-use-before-define
/*eslint-enable */
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";
export default {
    data: () =>({
editor: null,
    }),
    created(){
         const id = document.getElementById("drawflow");
    this.editor = new Drawflow(id, Vue);
    this.editor.reroute = true;
    this.editor.start();
    this.editor.clear();
    this.editor.zoom_out();
    this.editor.zoom_out();
    this.editor.zoom_out();
    },
    allowDrop(ev) {
      ev.preventDefault();
    },
    drag(ev) {
      ev.dataTransfer.setData("node", ev.target.getAttribute("data-node"));
    },
    drop(ev) {
      ev.preventDefault();
      var data = ev.dataTransfer.getData("node");
      this.newNode = {
        inputs: 0,
        outputs: 0,
        data: JSON.parse(data),
        x_pos: ev.clientX-250,
        y_pos: ev.clientY-250,
      };
      this.addNodeToDrawFlow();
    },
    addNodeToDrawFlow() {
      let currentData = this.editor.export();
      console.log(currentData)
    //   let newIndex = currentData?(Object.keys(currentData.drawflow.Home.data).length += 1):1;
    //   this.newNodeOptionsModal = false;
    //   this.editor.addNode(
    //     this.newNode.data.name + "_" + newIndex,
    //     this.newNode.data.name == "Start" ? 0 : 1,
    //     this.newNode.data.name == "Finish"
    //       ? 0
    //       : this.setOutputs(this.newNode.data.type.split("_")[0]),
    //     this.newNode.x_pos,
    //     this.newNode.y_pos,
    //     this.newNode.data.name == "Start"||this.newNode.data.name == "Finish"?"event":"multiple",
    //     this.newNode.data,
    //     this.newNode.data.type,
    //     "vue"
    //   );
    },
    save(){
        let data = this.editor.export();
        console.log(data)
    }
}
</script>
<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#drawflow {
  text-align: initial;
  width: 100%;
  height: 90vh;
  border: 1px solid rgb(131, 131, 131);
  background-size: 10px 10px;
  background-image: linear-gradient(
      to right,
      rgb(231, 231, 231) 1px,
      transparent 1px
    ),
    linear-gradient(to bottom, rgb(190, 190, 190), transparent 1px);
  background-repeat: repeat;
}
.drawflow-node.multiple .outputs .output {
  background: #898a89;
}

.drawflow,
.drawflow .parent-node {
    position: relative
}

.parent-drawflow {
    display: flex;
    overflow: hidden;
    touch-action: none;
    outline: 0
}

.drawflow {
    width: 100%;
    height: 100%;
    user-select: none
}

.drawflow .drawflow-node {
    display: flex;
    align-items: center;
    position: absolute;
    background: rgb(255, 255, 255);
    width: auto;
    min-height: 40px;
    border-radius: 10px;
    border: 2px solid #8b8b8b;
    color: #000;
    z-index: 2;
    padding: 15px
}

.drawflow .drawflow-node.selected {
    background: rgb(255, 255, 255);
    border: 2px solid #979899;
    box-shadow: 0px 2px 15px 2px #4ea9ff;
}

.drawflow .drawflow-node:hover {
    cursor: move
}

.drawflow .drawflow-node .inputs,
.drawflow .drawflow-node .outputs {
    width: 0
}

.drawflow .drawflow-node .drawflow_content_node {
    width: 100%;
    display: block
}

.drawflow .drawflow-node .input,
.drawflow .drawflow-node .output {
    position: relative;
    width: 20px;
    height: 20px;
    background: #fff;
    border-radius: 50%;
    border: 1px solid #8b8b8b;
    cursor: crosshair;
    z-index: 1;
    margin-bottom: 5px
}

.drawflow .drawflow-node .input {
    left: -27px;
    top: 2px;
    background: rgb(89, 152, 204)
}

.drawflow .drawflow-node .output {
    right: -3px;
    top: 2px;
}
.drawflow-node.event {
  width: 175px;
  height: 175px;
  line-height: 100px;
  border-radius: 50%;
  font-size: 25px;
  color: #fff;
  text-align: center;
  background: #ffffff;
    border: 2px solid #16b811;
}
.drawflow-node.multiple .outputs .output:nth-child(2) {
  background: #d81c16;
}
.drawflow-node.multiple .outputs .output:nth-child(3) {
  background: #f16609;
}

.drawflow-node.multiple .outputs .output:nth-child(2) .output:nth-child(1) {
    right: -3px;
    top: 2px;
    background: rgb(60, 190, 99)
}

.drawflow svg {
    z-index: 0;
    position: absolute;
    overflow: visible!important
}

.drawflow .connection {
    position: absolute;
    transform: translate(9999px, 9999px)
}

.drawflow .connection .main-path {
    fill: none;
    stroke-width: 2px;
    stroke: #8b8b8b;
    transform: translate(-9999px, -9999px)
}

.drawflow .connection .main-path:hover {
    stroke: #6cb8d6;
    cursor: pointer
}

.drawflow .connection .main-path.selected {
    stroke: #43b993
}

.drawflow .connection .point {
    cursor: move;
    stroke: #000;
    stroke-width: 2;
    fill: rgb(250, 248, 248);
    transform: translate(-9999px, -9999px)
}

.drawflow .connection .point.selected,
.drawflow .connection .point:hover {
    fill: #1266ab
}

.drawflow .main-path {
    fill: none;
    stroke-width: 5px;
    stroke: #4682b4
}

.drawflow .selectbox {
    z-index: 3;
    position: absolute;
    transform: translate(9999px, 9999px)
}

.drawflow .selectbox rect {
    fill: rgb(80, 80, 161);
    opacity: .5;
    stroke: #ff0;
    stroke-width: 5;
    stroke-opacity: .5;
    transform: translate(-9999px, -9999px)
}

.drawflow-delete {
    position: absolute;
    display: block;
    width: 30px;
    height: 30px;
    background: #eb2603;
    color: #fff;
    z-index: 4;
    border: 2px solid #fff;
    line-height: 30px;
    font-weight: 700;
    text-align: center;
    border-radius: 50%;
    font-family: monospace;
    cursor: pointer
}

.drawflow>.drawflow-delete {
    margin-left: -10px;
    margin-top: 10px
}

.parent-node .drawflow-delete {
    right: -15px;
    top: -15px
}
</style>